export default {
  formData: {},
  graphqlResults: {},
  funnelMeta: undefined
}
